import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

export default function data({ model, deleteEvent, editEvent }) {
  model = model ?? [];

  const Overall = ({ name, id, username }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <div>
        <button
          code={"btnEdit" + id}
          onClick={() => editEvent(`${id}`)}
          style={{ border: 0, backgroundColor: "transparent" }}
        >
          <MDBadge
            badgeContent="Sửa"
            color="success"
            variant="gradient"
            size="sm"
          />
        </button>
        <div style={{ height: 4 }} />
        <button
          style={{ border: 0, backgroundColor: "transparent" }}
          code={"btnDelete" + id}
          onClick={() => {
            deleteEvent(`${id}`);
          }}
        >
          <MDBadge
            badgeContent="Xóa"
            color="warning"
            variant="gradient"
            size="sm"
          />
        </button>
      </div>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{username}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const RowItem = ({ value }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography variant="caption">{value}</MDTypography>
    </MDBox>
  );

  const rows = [];

  model.forEach((item) => {
    rows.push({
      overall: (
        <Overall
          name={item.fullName}
          id={item.id ?? 0}
          username={item.username}
        />
      ),
      email: <RowItem value={item.email} />,
      status: <RowItem value={item.status} />,
    });
  });

  return {
    columns: [
      { Header: "Họ tên", accessor: "overall", width: "45%", align: "left" },
      { Header: "Email", accessor: "email", align: "left" },
      { Header: "Trạng thái", accessor: "status", align: "left" },
    ],
    rows: rows,
  };
}
